import once from 'lodash/once';
import { createContext, useContext } from 'react';

import type { IContext } from './models';

export const createRouterContext = once(<S>() => createContext<IContext<S>>({} as IContext<S>));

export const useRouterContext = <S = string>() => useContext(createRouterContext<S>());
